import React from "react";
import { Col, Row } from "react-bootstrap";

const NotificationLayout = ({ title, subtitle, button }) => {
  return (
    <Row>
      <Col sm={8}>
        <div>
          <div className="fw-bold font-size-5 mb-1">{title}</div>
          <div className="font-secondary">{subtitle}</div>
        </div>
      </Col>
      <Col sm={4} className="d-flex justify-content-center align-items-center">
        {button}
      </Col>
    </Row>
  );
};

export default NotificationLayout;
